import HeaderTabsDesktop from './header-tabs-desktop.component';
import HeaderTabsMobile from './header-tabs-mobile.component';
import forDevice from '../../hoc/for-device';
import { flowRight } from 'lodash';
import { RootState } from '../../reducers/root-state';
import { MainPageType } from './models';
import { getActiveFeedName } from './store/header-tabs.selectors';
import { connect } from '../../../common/components/runtime-context';
import { getIsMainPageEnabled } from '../../selectors/app-settings-selectors';

const HeaderTabs = forDevice(HeaderTabsMobile, HeaderTabsDesktop);

const mapRuntimeToProps = (state: RootState, _: any, __: any, host: any) => {
  const isMainPageCategoriesList = getIsMainPageEnabled(state, host.style);
  const mainPageType = isMainPageCategoriesList ? MainPageType.Categories : MainPageType.Posts;

  return {
    mainPageType,
    activeFeedType: getActiveFeedName(state, mainPageType),
  };
};

export default flowRight(connect(mapRuntimeToProps))(HeaderTabs);
